export const EXTRA = [
  'Vanilla Skins',
  'StatTrak only',
  'No StatTrak',
  'Souvenir',
  'No Souvenir',
];

export const TYPE = [
  "Weapon",
  "Charm",
  "Agent",
  "Key",
  "Container",
  "Sticker",
  "Graffiti",
  "Knife",
  "Gloves",
  "Music Kit",
  "Patch",
  "Pass",
  "Gift",
  "Tool",
  "Tag",
];

export const PISTOLS = [
  'Desert Eagle',
  'Glock-18',
  'R8 Revolver',
  'USP-S',
  'CZ75-Auto',
  'Five-SeveN',
  'P250',
  'Tec-9',
  'Dual Berettas',
  'P2000',
];

export const SMG = ['MP9', 'MAC-10', 'PP-Bizon', 'MP7', 'UMP-45', 'P90', 'MP5-SD'];

export const RIFLES = ['FAMAS', 'Galil AR', 'M4A4', 'M4A1-S', 'AK-47', 'AUG', 'SG 553'];

export const SNIPERS = ['SSG 08', 'AWP', 'SCAR-20', 'G3SG1'];

export const SHOTGUNS = ['Nova', 'XM1014', 'MAG-7', 'Sawed-Off'];

export const MACHINEGUNS = ['M249', 'Negev'];

export const KNIVES = [
  'Bayonet',
  'Butterfly Knife',
  'Falchion Knife',
  'Flip Knife',
  'Gut Knife',
  'Huntsman Knife',
  'Karambit',
  'M9 Bayonet',
  'Shadow Daggers',
  'Navaja Knife',
  'Stiletto Knife',
  'Talon Knife',
  'Ursus Knife',
  'Bowie Knife',
  'Skeleton Knife',
  'Paracord Knife',
  'Survival Knife',
  'Nomad Knife',
  'Classic Knife',
  'Kukri Knife',
];

export const EQUIPMENT = ['Zeus X27'];

export const UNIQUE = ['Rare phase', 'Rare float', 'Rare items', 'Rare stickers'];

export const PHASE = [
  'Phase 1',
  'Phase 2',
  'Phase 3',
  'Phase 4',
  'Ruby',
  'Emerald',
  'Sapphire',
  'Black Pearl',
];

export const RARITY = [
  'Consumer',
  'Industrial',
  'Mil-Spec',
  'Restricted',
  'Classified',
  'Covert',
  'Contraband',
  'Distinguished',
  'Exceptional',
  'Superior',
  'Master',
  'Base grade',
  'Extraordinary',
  'High grade',
  'Remarkable',
  'Exotic',
];

export const RARE_PATTERN = [
  'Blue Gem | Case Hardened',
  'Tier 1 | Case Hardened',
  'Tier 2 | Case Hardened',
  'Tier 3 | Case Hardened',
  'Tier 4 | Case Hardened',
  '1th Max | Marble Fade',
  '2nd Max | Marble Fade',
  '3th Max | Marble Fade',
  '4th Max | Marble Fade',
  '5th Max | Marble Fade',
  '6th Max | Marble Fade',
  '7th Max | Marble Fade',
  '8th Max | Marble Fade',
  '9th Max | Marble Fade',
  '10th Max | Marble Fade',
  'Max fake | Marble Fade',
  'Fake Fire & Ice | Marble Fade',
  'Tier 1 | Marble Fade',
  'Tier 2 | Marble Fade',
  'Tier 3 | Marble Fade',
  'Tier 4 | Marble Fade',
  'Tier 1 | Crimson Web',
  'Tier 2 | Crimson Web',
  'Tier 3 | Crimson Web',
];
